import config from "../config/config";
import Vue from "vue";
import i18n from "@/config/i18n";
import { piThUserDate } from "@/utils/time.helper";
const time = (value, type) => {
    if (value) {
        if (typeof value === "number") {
            const typeStr = type || "yyyy-mm-dd hh:mm:ss";
            return piThUserDate(value, typeStr);
        }
        else {
            return value;
        }
    }
    else {
        return "";
    }
};
const Fixed = (value, type) => {
    if (typeof value === "number" && !isNaN(value)) {
        const n = type && type >= 0 ? type : 2;
        return value.toFixed(n);
    }
    else {
        return 0;
    }
};
const fileUrl = (value) => {
    if (value) {
        return config.fileImg + value;
    }
    else {
        return "";
    }
};
const defaultText = (value) => {
    if (value || value == 0) {
        return value;
    }
    else {
        return "--";
    }
};
const bankCard = (value) => {
    if (typeof value == "number") {
        value = value + "";
    }
    return value.replace(/\s/g, "").replace(/(.{4})/g, "$1 ");
};
const money = (value) => {
    if (value > 10000) {
        return (value / 10000).toFixed(1) + i18n.t("unitText.wyuan");
    }
    else if (value != null && value != undefined) {
        return value.toFixed(2);
    }
    else {
        return "";
    }
};
export const defaultNumber = (value) => {
    if (value || value == 0) {
        return value;
    }
    else {
        return 0;
    }
};
export const percentage = (value) => {
    if (value > 0) {
        return value + "%";
    }
    else {
        return "-";
    }
};
export const percentageValue = (value, num) => {
    if (typeof value == "number") {
        num = 2 || num;
        value = parseFloat((value * 100).toFixed(num));
        return value + "%";
    }
    else {
        return "-";
    }
};
export const numberMax = (value, isUnit) => {
    const val = value || 0;
    isUnit = isUnit != undefined ? isUnit : true;
    const unitText = isUnit ? i18n.t("unitText.wan") + "" : "";
    const text = val > 10000 ? (val / 10000).toFixed(2) + unitText : val;
    return text;
};
export const localUrl = (value) => {
    if (value && value.indexOf("http") == 0) {
        return value;
    }
    else if (value && typeof value !== "undefined") {
        return config.host + value;
    }
    return "";
};
Vue.filter("time", time);
Vue.filter("toFixed", Fixed);
Vue.filter("fileUrl", fileUrl);
Vue.filter("defaultText", defaultText);
Vue.filter("bankCard", bankCard);
Vue.filter("money", money);
Vue.filter("defaultNumber", defaultNumber);
Vue.filter("percentage", percentage);
Vue.filter("percentageValue", percentageValue);
Vue.filter("numberMax", numberMax);
Vue.filter("localUrl", localUrl);
